
import { defineComponent } from "vue";

export default defineComponent({
  name: "file-component",
  props: {
    fileTitle: String,

    subTitle: String,

    fileType: String,
  },
  components: {},
});
